import { render, staticRenderFns } from "./endorsement-info.vue?vue&type=template&id=7be25e44&scoped=true&"
import script from "./endorsement-info.vue?vue&type=script&lang=js&"
export * from "./endorsement-info.vue?vue&type=script&lang=js&"
import style0 from "./endorsement-info.vue?vue&type=style&index=0&id=7be25e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be25e44",
  null
  
)

export default component.exports